import type { BrainstormOptionItem, BrainstormOptionsData } from '@frontend/api-types';
import { BrainstormOptionCard, Text, YStack } from '@frontend/web-react';

type TaskChatBrainstormOptionsProps = {
  data: BrainstormOptionsData;
  onOptionSelect?: (option: BrainstormOptionItem, index: number) => void;
};

const FINAL_PHASE_LABELS = ['Good', 'Better', 'Best'];

export const TaskChatBrainstormOptions = ({ data, onOptionSelect }: TaskChatBrainstormOptionsProps) => {
  const { followupQuestion, options, phase, summary } = data;

  const getOptionLabel = (index: number) =>
    phase === 'final' ? FINAL_PHASE_LABELS[index] ?? `Option ${index + 1}` : `Option ${index + 1}`;

  return (
    <YStack className="gap-md py-md">
      <Text className="text-neutral-950" type="p-md">
        {summary}
      </Text>
      <YStack className="gap-sm">
        {options.map((option, idx) => (
          <BrainstormOptionCard
            key={`${option.title}-${idx}`}
            label={getOptionLabel(idx)}
            onClick={onOptionSelect ? () => onOptionSelect(option, idx) : undefined}
            option={option}
            phase={phase}
          />
        ))}
      </YStack>
      {followupQuestion ? (
        <Text className="text-neutral-950 font-medium" type="p-sm">
          {followupQuestion}
        </Text>
      ) : null}
    </YStack>
  );
};
